import { ProjectData } from 'ontime-types';

export const projectDataPlaceholder: ProjectData = {
  title: '',
  description: '',
  publicUrl: '',
  publicInfo: '',
  backstageUrl: '',
  backstageInfo: '',
  projectLogo: null,
};
